"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserFeedbackForm = void 0;
var core_1 = require("@honeybadger-io/core");
var globalThisOrWindow = core_1.Util.globalThisOrWindow;
var BrowserFeedbackForm = /** @class */ (function () {
    function BrowserFeedbackForm(config, logger, scriptUrl) {
        this.config = config;
        this.logger = logger;
        this.scriptUrl = scriptUrl;
    }
    /* ROLLUP_STRIP_CODE_CHROME_EXTENSION_START */
    BrowserFeedbackForm.prototype.appendUserFeedbackTag = function (window, options) {
        if (options === void 0) { options = {}; }
        var script = window.document.createElement('script');
        script.setAttribute('src', this.scriptUrl);
        script.setAttribute('async', 'true');
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (global.document.head || global.document.body).appendChild(script);
    };
    BrowserFeedbackForm.prototype.isUserFeedbackUrlAlreadyVisible = function () {
        var global = globalThisOrWindow();
        var feedbackScriptUrl = this.scriptUrl;
        for (var i = 0; i < global.document.scripts.length; i++) {
            var script = global.document.scripts[i];
            if (script.src === feedbackScriptUrl) {
                return true;
            }
        }
        return false;
    };
    /* ROLLUP_STRIP_CODE_CHROME_EXTENSION_END */
    BrowserFeedbackForm.prototype.show = function (lastNoticeId, options) {
        if (options === void 0) { options = {}; }
        if (typeof (this.appendUserFeedbackTag) !== 'function') {
            this.logger.debug('Feedback form is not available in this environment');
            return;
        }
        if (!this.config || !this.config.apiKey) {
            this.logger.debug('Client not initialized');
            return;
        }
        if (!lastNoticeId) {
            this.logger.debug("Can't show user feedback form without a notice already reported");
            return;
        }
        var global = globalThisOrWindow();
        if (typeof global.document === 'undefined') {
            this.logger.debug('global.document is undefined. Cannot attach script');
            return;
        }
        if (this.isUserFeedbackUrlAlreadyVisible()) {
            this.logger.debug('User feedback form is already visible');
            return;
        }
        global['honeybadgerUserFeedbackOptions'] = __assign(__assign({}, options), { apiKey: this.config.apiKey, endpoint: this.config.userFeedbackEndpoint, noticeId: lastNoticeId });
        this.appendUserFeedbackTag(global, options);
    };
    return BrowserFeedbackForm;
}());
exports.BrowserFeedbackForm = BrowserFeedbackForm;
//# sourceMappingURL=feedback-form.js.map